// Update contents object below
const contents = {
  header: 'AWS Intel', //update with your client name
  logoTooltip: {
    href: '', //where the logo click drives to
    copy: '' // tooltip content
  },
  hero: {
    background: 'video', //options: "image" or "video"
    logoPlacement: 'top', //options: "top" or "center"
    title: 'Fighting Hunger in the UK with AI ',
    copy:
      'How AI and the cloud are helping manage the food supply chain and providing millions of meals to vulnerable people.'
  },
  inlinePhotos: {
    size: 'bodyWidth', //options: "fullBleed" or "bodyWidth"
    contents: [
      { class: 'photo1', caption: 'caption' },
      { class: 'photo2', caption: 'caption' },
      { class: 'photo3', caption: 'caption' },
      { class: 'photo4', caption: 'caption' },
      { class: 'photo5', caption: 'caption' },
      { class: 'photo6', caption: 'caption' },
      { class: 'photo7', caption: 'caption' },
      { class: 'photo8', caption: 'caption' }
    ] //add more objects in the array if you have more than one photo
  },
  ctaTooltip: {
    href:
      'https://aws.amazon.com/intel/?trk=ce77de9a-aaec-4791-af9a-7482b43d7c91&sc_channel=display%20ads?utm_source=cnn&utm_medium=hyperlink&utm_campaign=gc-ngitl&utm_content=infrastructureinnovation_articlecta&utm_creative=link',
    copy: 'https://aws.amazon.com/intel/' //tooltip content
  },
  pullQuoteContent: {
    pullQuote1:
      'Players who achieve extremely high scores in the app sometimes even get a chance to connect with a professional sports club for a tryout. “We’ve actually had a player who has done drills and had a call from the club on the same day. It’s happened that quickly,” says Richard Felton-Thomas, Director of Sport Science and COO at AiSCOUT. “It’s incredibly rewarding when a player gets signed who might never have been seen otherwise. It’s heartwarming, and it’s also a validation for the ability of this technology to change someone’s life.”',
    pullQuote2:
      'In fact, the program was such a huge success that India announced that it would make the Co-WIN platform open source so that all countries could save lives and protect health with a modern, cloud-based vaccine registration platform.'
  }
};

export default contents;
